import React from 'react';
import {
  componentFromProp,
  compose,
  renderNothing,
  withHandlers,
  withPropsOnChange,
} from 'recompose';
import { Button, Input, Select } from 'components/Form';
import { Grid, Typo, Rhythm } from 'components/Layout';
import { Icon } from 'components/Icon';
import Code from 'components/Code';
import types from './types';
import { isFunction } from 'lodash';
import cx from 'classnames';

import styles from './styles.css';

const CUSTOM_FIELD_PREFIX = 'custom_fields.';
const RATING = 'reviews.average_score';

const toBoolean = (value) => value === 'true';
const fromBoolean = (value) => (value ? 'true' : 'false');

const mapTypes = (name, type) =>
  ({ category: 'category' }[name] || { string: 'text', number: 'range' }[type]);

const Property = ({ render, field, ...rest }) =>
  isFunction(render)
    ? render({ ...rest, field })
    : React.cloneElement(render, {
        ...rest,
        name: [field, render.props.name].join('.'),
      });

export default compose(
  withHandlers({
    onRemove:
      ({ onRemove, index }) =>
      () =>
        onRemove(index),
  }),
  withPropsOnChange(
    ['data', 'meta'],
    ({ data, meta, renderNote }) =>
      renderNote && {
        notification: renderNote(data, meta),
      }
  )
)(
  ({
    rowClass,
    columns,
    index,
    field,
    data,
    onRemove,
    showRemove,
    children,
    notification,
    totalRows,
    keepLast,
    divider,
  }: any) => {
    const isShowRemove = !showRemove || showRemove(data);
    return (
      <>
        {!!divider && !!index && divider}
        <div className={cx(styles.row, rowClass)}>
          <div className={styles.wrap}>
            <Grid columns={columns || '3'} className={styles.content}>
              {children.map((child: any, i) => (
                <Property
                  key={i}
                  columnclass={styles.column}
                  render={child}
                  data={data}
                  field={field}
                />
              ))}
            </Grid>
            {!(keepLast && totalRows <= 1) && isShowRemove && (
              <button className={styles.remove} onClick={onRemove}>
                <Icon name="trash" width={24} height={24} />
              </button>
            )}
          </div>
          {notification}
        </div>
      </>
    );
  }
);
